/* unplugin-vue-components disabled */import script from "./AnalyzeMoney.vue?vue&type=script&setup=true&lang=js"
export * from "./AnalyzeMoney.vue?vue&type=script&setup=true&lang=js"

import "./AnalyzeMoney.vue?vue&type=style&index=0&id=4c9e70de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c9e70de"]])

export default __exports__